<template>
  <div>
    <b-container>
      <b-row class="mt-3 justify-content-md-center">
        <b-col
          cols="6"
          md="4"
          class="text-right"
        >
          <img
            style="width: 80%"
            :src="logo"
            alt="logo"
          >
        </b-col>
        <b-col
          class="info-wrapper"
          cols="6"
          md="4" 
        >
          <div>
            <div class="cn-text">阿六敦蒙古语工具站</div>
            <div class="mn-text">ᠠᠯᠲᠠᠨ ᠮᠣᠩᠭᠣᠯ ᠬᠡᠷᠡᠭᠰᠡᠯ ᠰᠠᠶᠢᠲᠤ</div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3 justify-content-md-center">
        <b-col
          cols="6"
          md="4"
          class="card-wrapper left-wrapper"
        >
          <b-card
            class="item-card"
            bg-variant="warning"
            text-variant="dark"
            @click="handleIndex"
          >
            <div class="icon-wrapper">
              <b-icon-house-fill></b-icon-house-fill>
            </div>
            <div>
              主页
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="6"
          md="4"
          class="card-wrapper right-wrapper"
        >
          <b-card
            class="item-card"
            bg-variant="warning"
            text-variant="dark"
            @click="handleComment"
          >
            <div class="icon-wrapper">
              <b-icon-chat-left-text-fill></b-icon-chat-left-text-fill>
            </div>
            <div>
              反馈
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="justify-content-md-center">
        <b-col
          cols="6"
          md="4"
          class="card-wrapper left-wrapper"
        >
          <b-card
            class="item-card"
            bg-variant="warning"
            text-variant="dark"
            @click="handleEMail"
          >
            <div class="icon-wrapper">
              <b-icon-envelope-fill></b-icon-envelope-fill>
            </div>
            <div>
              联系
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="6"
          md="4"
          class="card-wrapper right-wrapper"
        >
          <b-card
            class="item-card"
            bg-variant="warning"
            text-variant="dark"
            v-b-modal.donate-modal
          >
            <div class="icon-wrapper">
              <b-icon-hand-thumbs-up-fill></b-icon-hand-thumbs-up-fill>
            </div>
            <div>
              打赏
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-5 text-center">
        <b-col>
          <div class="version-info">
            阿六敦背单词 V3.0 <b-link href="https://space.bilibili.com/13957052/">@济北周南</b-link>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="donate-modal"
      title="微信赞赏码"
      centered
      hide-footer
    >
      <b-row>
        <b-col>
         <img :src="zsm" alt="赞赏码" width="100%">
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
import zsm from '@/assets/zsm.jpg'
export default {
  name: 'AboutPage',

  data() {
    return {
      logo,
      zsm,
    }
  },

  methods: {
    handleIndex() {
      window.location.href = 'https://alt-mgl.github.io'
    },
    handleEMail() {
      window.location.href = 'mailto://joenahm@yeah.net'
    },
    handleComment() {
      window.location.href = 'https://support.qq.com/products/596716'
    },
  },
}
</script>

<style scoped>
.info-wrapper {
  display: flex;
  align-items: center;
  text-align: center;
}

@media screen and (min-width: 995px) {
  .cn-text {
    font-size: 26px;
  }
  .mn-text {
    font-size: 24px;
  }
}
@media screen and (max-width: 994px) {
  .cn-text {
    font-size: 22px;
  }
  .mn-text {
    font-size: 20px;
  }
}
@media screen and (max-width: 550px) {
  .cn-text {
    font-size: 16px;
  }
  .mn-text {
    font-size: 16px;
  }
}

.mn-text {
  font-family: 'Onon Sonin MGL';
}

.card-wrapper {
  padding: 5px;
}

.left-wrapper {
  padding-left: 10px;
}

.right-wrapper {
  padding-right: 10px
}

.item-card {
  text-align: center;
}

.icon-wrapper {
  font-size: 38px;
  margin: 10px 0;
}

.version-info {
  font-size: 18px;
  color: #ccc;
}
</style>
